import * as React from 'react';
import { Calendar } from 'react-modern-calendar-datepicker';
import * as styles from './RangeCalendar.css';
import { locale } from './locale';
import { ICalendarDateRange } from './types';
import { formatCalendarDateRange } from './utils/formatCalendarDateRange';
import { formatDateRange } from './utils/formatDateRange';
import { IDateRange } from '../../types/dateRange';
import { formatDate } from './utils/formatDate';

interface IRangeCalendarProps {
  open: boolean;
  value: IDateRange;
  minDate?: Date;
  maxDate?: Date;
  onChange(dateRange: IDateRange): void;
}

export const RangeCalendar = ({ value, open, minDate, maxDate, onChange }: IRangeCalendarProps) => {
  const formattedMinDate = React.useMemo(() => (minDate ? formatDate(minDate) : undefined), [minDate]);
  const formattedMaxDate = React.useMemo(() => (maxDate ? formatDate(maxDate) : undefined), [maxDate]);
  const formattedValue = React.useMemo(() => formatDateRange(value), [value]);

  const handleChange = React.useCallback(
    (value: ICalendarDateRange) => {
      const dateRange = formatCalendarDateRange(value);

      onChange(dateRange);
    },
    [onChange],
  );

  /* istanbul ignore next */
  React.useEffect(() => {
    // Обычный импорт не работает, поскольку серверная сборка не предусматривает обработку css из node_modules
    import('react-modern-calendar-datepicker/lib/DatePicker.css');
  }, []);

  // Календарь не отрендерится, но стили для него загрузятся (см. useEffect выше)
  if (!open) {
    return null;
  }

  return (
    <Calendar
      value={formattedValue}
      onChange={handleChange}
      shouldHighlightWeekends
      colorPrimary="#0468FF"
      colorPrimaryLight="rgba(4, 104, 255, 0.1)"
      locale={locale}
      minimumDate={formattedMinDate}
      maximumDate={formattedMaxDate}
      calendarTodayClassName={styles['today']}
      calendarClassName={styles['calendar']}
    />
  );
};
